/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Trust3_NInputs */

const es_landing_trust3_n = /** @type {(inputs: Landing_Trust3_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15%`)
};

const gl_landing_trust3_n = /** @type {(inputs: Landing_Trust3_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15%`)
};

const en_landing_trust3_n = /** @type {(inputs: Landing_Trust3_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15%`)
};

/**
* | output |
* | --- |
* | "15%" |
*
* @param {Landing_Trust3_NInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_trust3_n = /** @type {((inputs?: Landing_Trust3_NInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Trust3_NInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_trust3_n(inputs)
	if (locale === "en") return en_landing_trust3_n(inputs)
	return es_landing_trust3_n(inputs)
});